export const salasConfig = {
    aula: 'mk7nZU9o50uXXUi4F9Tj',
    juntas: 'ucuwSxZHDZk8iB2dhdAe',
    polivalente: 'VCrxKEI55awpqy4OcFMR'
  };
  